// Certificate.js
import React from "react";
import { Box, Typography, Paper, Grid, Avatar } from "@mui/material";
import {
  SpaOutlined as PaluzIcon,
  MedicalServicesOutlined as SignatureIcon,
} from "@mui/icons-material";
import footer from "assets/certificadoFooter.png";
import logo from "assets/paluz-logo.png";
import icon from "assets/paluz-icon-2.png";

// --- MODIFICACIÓN AQUÍ: Se añade la prop "forceDesktop" ---
export const Certificate = React.forwardRef(
  ({ user, exam, forceDesktop = false }, ref) => {
    // Colores extraídos de tu imagen
    const tealBorder = "#80cbc4";
    const darkGreyText = "#424242";

    return (
      // Contenedor principal
      <Box
        ref={ref}
        sx={{
          width: forceDesktop ? "842px" : { xs: "90vw", sm: "842px" },
          height: forceDesktop ? "595px" : { xs: "auto", sm: "595px" },
          aspectRatio: "1.41 / 1",
          bgcolor: "background.paper",
          position: "relative",
          overflow: "hidden",
          boxSizing: "border-box",
        }}
      >
        {/* Capa 1: El Marco del Borde */}
        <Box
          sx={{
            position: "absolute",
            inset: "10px",
            border: `2px solid ${tealBorder}`,
            borderRadius: "20px",
            zIndex: 1,
          }}
        />

        {/* Capa 3: El Contenido de Texto (encima de todo) */}
        <Paper
          elevation={0}
          sx={{
            position: "absolute",
            inset: "10px",
            display: "flex",
            flexDirection: "column",
            p: forceDesktop ? 5 : { xs: 2, sm: 5 },
            pb: forceDesktop ? "100px" : { xs: 8, sm: "100px" },
            boxSizing: "border-box",
            textAlign: "center",
            backgroundColor: "transparent",
            zIndex: 3, // z-index más alto para que el texto esté siempre arriba
          }}
        >
          {/* Encabezado */}
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 1,
                color: tealBorder,
              }}
            >
              <Box
                component="img"
                src={logo}
                alt="Logo Paluz"
                sx={{
                  width: "20%",
                  height: "auto",
                }}
              />
            </Box>
            <Typography
              variant="h1"
              sx={{
                fontFamily: "serif",
                //fontWeight: "bold",
                color: darkGreyText,
                mt: 2,
                letterSpacing: 2,
              }}
            >
              RECONOCIMIENTO
            </Typography>
            <Typography
              variant="h3"
              sx={{
                fontFamily: "Arial",
                //fontWeight: "bold",
                color: darkGreyText,
                letterSpacing: 2,
                mt: 1,
              }}
            >
              QUE SE OTORGA A
            </Typography>
          </Box>

          {/* Nombre del Usuario (Placeholder) */}
          <Box sx={{ my: 2 }}>
            <Typography
              variant="h2"
              sx={{
                fontFamily: "Times New Roman",
                fontWeight: "bold",
                color: darkGreyText,
              }}
            >
              {user?.name || "Nombre del Usuario"}
            </Typography>
            <Typography
              variant="h2"
              sx={{
                fontFamily: "Times New Roman",
                fontWeight: "bold",
                color: darkGreyText,
              }}
            >
              {user?.cedula || "V-00.000.000"}
              {exam?.title || "Titulo de Examen"}
            </Typography>
          </Box>

          {/* Cuerpo del texto y Firmas */}
          <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
            <Box
              sx={{
                flexGrow: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  maxWidth: "85%",
                  mx: "auto",
                  color: darkGreyText,
                  lineHeight: 1.7,
                }}
              >
                Por su valiosa <b>contribución</b> en tiempo, <b>vocación</b> y
                servicio durante estos <b>años</b> de tu <b>preparación</b>{" "}
                profesional, donde juntos pudimos brindar <b>atención médica</b>{" "}
                y nutricional, a adultos y <b>niños</b>, en las zonas <b>más</b>{" "}
                vulnerables del <b>país</b>. Nos honra haber contado contigo.
              </Typography>
              <Typography
                variant="h6"
                sx={{ color: darkGreyText, mt: 2, fontWeight: "bold" }}
              >
                {exam?.dateTaken
                  ? new Date(exam.dateTaken).toLocaleDateString("es-ES", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })
                  : "28 de Mayo de 2025"}
              </Typography>
            </Box>

            {/* Firmas */}
            <Grid container spacing={2} sx={{ mt: "auto" }} alignItems="center">
              <Grid item xs={5} sx={{ textAlign: "center" }}>
                <Typography
                  variant="h6"
                  sx={{ fontFamily: "serif", color: darkGreyText }}
                >
                  GIOVANNI VARELA
                </Typography>
                <Typography
                  variant="body1"
                  color="text.secondary"
                  sx={{ fontWeight: "bold" }}
                >
                  Director
                </Typography>
              </Grid>
              <Grid
                item
                xs={2}
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <Box
                  component="img"
                  src={icon}
                  alt="Icono Paluz"
                  sx={{
                    width: "60%",
                    height: "auto",
                  }}
                />
              </Grid>
              <Grid item xs={5} sx={{ textAlign: "center" }}>
                <Typography
                  variant="h6"
                  sx={{ fontFamily: "serif", color: darkGreyText }}
                >
                  GUSTAVO BAPTISTA
                </Typography>
                <Typography
                  variant="body1"
                  color="text.secondary"
                  sx={{ fontWeight: "bold" }}
                >
                  Director
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Paper>

        {/* Capa 2: La imagen del footer */}
        <Box
          component="img"
          src={footer}
          alt="Decoración del certificado"
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "100%",
            height: "auto",
            maxHeight: "120px",
            zIndex: 2,
          }}
        />
      </Box>
    );
  }
);
